import api from '.';

export const Duplicar = (selectedUUIDs) => api.post('/centroCustoLimite/Duplicar', selectedUUIDs);
